import type { ComponentProps } from 'react';

import * as LabelPrimitive from '@radix-ui/react-label';
import { cn } from '@repo/lib/cn';

export function Label(labelProps: ComponentProps<typeof LabelPrimitive.Root>) {
  const { className, ...props } = labelProps;
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'text-foreground text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-60 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className
      )}
      {...props}
    />
  );
}
